// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface MinecraftEventTrigger {
  event: string;
  target: string;
}
